import styled from 'styled-components'

import { FormTreeSelect } from '../../../common/components/sections'

const StyledUnknownWordsFormTreeSelect = styled(FormTreeSelect)`
  .ant-select-selector {
    margin: 0.25rem 0;
    width: 100%;
  }
`

export default StyledUnknownWordsFormTreeSelect
